import { render, staticRenderFns } from "./succeed2.vue?vue&type=template&id=112ddbe6&scoped=true&"
import script from "./succeed2.vue?vue&type=script&lang=js&"
export * from "./succeed2.vue?vue&type=script&lang=js&"
import style0 from "./succeed2.vue?vue&type=style&index=0&id=112ddbe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112ddbe6",
  null
  
)

export default component.exports